import { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import PublicLayout from "@/components/public/PublicLayout";
import Home from "@/pages/public/Home";
import InfoPage from "@/pages/public/InfoPage";
import NotFound from "@/pages/public/NotFound";
import { PAGES, LEGAL } from "@/data/site";

const Franchise = lazy(() => import("@/pages/public/Franchise"));
const Contact = lazy(() => import("@/pages/public/Contact"));
const Legal = lazy(() => import("@/pages/public/Legal"));
const EspaceApp = lazy(() => import("@/pages/espace/EspaceApp"));
const SignQuote = lazy(() => import("@/pages/public/SignQuote"));
const Blog = lazy(() => import("@/pages/public/Blog"));
const BlogPost = lazy(() => import("@/pages/public/BlogPost"));

const Fallback = () => <div className="flex min-h-[50vh] items-center justify-center text-sm text-muted-foreground">Chargement…</div>;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<Fallback />}>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              {Object.keys(PAGES).map((p) => <Route key={p} path={p} element={<InfoPage />} />)}
              <Route path="/franchise" element={<Franchise />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              {Object.keys(LEGAL).map((p) => <Route key={p} path={p} element={<Legal />} />)}
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/espace/*" element={<EspaceApp />} />
            <Route path="/devis/signer/:token" element={<SignQuote />} />
            <Route path="/sign-in/*" element={<EspaceApp />} />
            <Route path="/sign-up/*" element={<EspaceApp />} />
          </Routes>
        </Suspense>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
